import { APP_UI_CHANGE_THEME_DARK, APP_UI_CHANGE_THEME_LIGHT } from 'constants/ActionTypes';

export const setDarkTheme = () => {
  return {
    type: APP_UI_CHANGE_THEME_DARK,
  };
};

export const setLightTheme = () => {
  return {
    type: APP_UI_CHANGE_THEME_LIGHT,
  };
};
